module.exports = __webpack_public_path__ + "img/8.ef173b50.jpg";